import { getStrapiMedia } from "../../lib/utils";

export default function ImageContainer({
  media,
  style: parentStyle = { width: "100vw", height: "100vh" },
}) {
  return (
    <div
      style={{
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundImage: `url(${getStrapiMedia(media)})`,
        ...parentStyle,
      }}
    ></div>
  );
}
